// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout-module--wrapper--1fT28","footer":"Layout-module--footer--39xYc"};